import { createColumnHelper } from '@tanstack/react-table';

import { HelmRepository } from '../types';

export const columnHelper = createColumnHelper<HelmRepository>();
